import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import css from "./style.scss";

const PopoverMenu = ({ isOpen, onClose, items = [], position = "right", customWidth = null, title = null }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    // Dynamically calculate the top offset based on menu height
    // Adding 6px as a small margin as per design + 4px to adjust with border
    if (isOpen && menuRef?.current) {
      const childrenHeight = menuRef.current.scrollHeight;
      menuRef.current.style.setProperty('--menu-top-offset', `-${childrenHeight + 10}px`);
    }
  }, [isOpen, items]);

  if (!isOpen) return null;

  const getWidthByTitle = (title, customWidth) => {
    if (customWidth) return customWidth;

    switch (title) {
      case "Add Item":
        return 190;
      case "View Type":
        return 166;
      default:
        return 230;
    }
  };

  return (
    <div
      ref={menuRef}
      className={classNames(
        css.popoverMenu,
        {
          [css.left]: position === "left",
          [css.right]: position === "right",
          [css.topLeft]: position === "top-left",
          [css.hasTitle]: !!title,
        }
      )}
      style={{ width: `${getWidthByTitle(title, customWidth)}px` }}
    >
      {title && <div className={classNames(css.popoverTitle, css.popoverItem)}>{title}</div>}
      {items.map((item, index) => (
        <div
          key={index}
          className={css.popoverItem}
          onClick={() => {
            item.onClick?.();
            onClose?.();
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default PopoverMenu;
